/**
 * @generated SignedSource<<7df33569ffc3c771ca0e4a662a27a274>>
 * @relayHash 2846e760133e26b36208b096f9a6e280
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ec69288cede4604a8de2739752717c006b68dce62805914f018e3348aa1cc56a

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserNavigatorQuery$variables = {
  id: string;
};
export type UserNavigatorQuery$data = {
  readonly nodeBySlugId: {
    readonly __typename: "User";
    readonly totalEventAttendance: {
      readonly totalCount: number;
    };
    readonly totalPresentations: {
      readonly totalCount: number;
    };
    readonly " $fragmentSpreads": FragmentRefs<"UserCardNew_user" | "UserMetadata_user">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type UserNavigatorQuery = {
  response: UserNavigatorQuery$data;
  variables: UserNavigatorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
],
v4 = {
  "alias": "totalEventAttendance",
  "args": null,
  "concreteType": "EventsConnection",
  "kind": "LinkedField",
  "name": "eventAttendance",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v5 = {
  "alias": "totalPresentations",
  "args": null,
  "concreteType": "PresentationsConnection",
  "kind": "LinkedField",
  "name": "presentationsByPresenterId",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v8 = {
  "kind": "Literal",
  "name": "dpr",
  "value": 3
},
v9 = {
  "kind": "Literal",
  "name": "fit",
  "value": "cover"
},
v10 = {
  "kind": "Literal",
  "name": "h",
  "value": 100
},
v11 = {
  "kind": "Literal",
  "name": "w",
  "value": 100
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v14 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GuildMembershipsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GuildMembership",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "membershipLevel",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Guild",
            "kind": "LinkedField",
            "name": "guild",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "primaryPhoto",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "fields": [
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/)
                        ],
                        "kind": "ObjectValue",
                        "name": "transform"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "transformUrl",
                    "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":100,\"w\":100})"
                  },
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserNavigatorQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodeBySlugId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserCardNew_user"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserMetadata_user"
              },
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "type": "User",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserNavigatorQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodeBySlugId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bio",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isMe",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailMd5",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "primaryPhoto",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "fields": [
                          (v8/*: any*/),
                          (v9/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "fo",
                            "value": "face"
                          },
                          (v10/*: any*/),
                          (v11/*: any*/)
                        ],
                        "kind": "ObjectValue",
                        "name": "transform"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "transformUrl",
                    "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"fo\":\"face\",\"h\":100,\"w\":100})"
                  },
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "fields": [
                      (v8/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/)
                    ],
                    "kind": "ObjectValue",
                    "name": "transform"
                  }
                ],
                "kind": "ScalarField",
                "name": "defaultAvatarUrl",
                "storageKey": "defaultAvatarUrl(transform:{\"dpr\":3,\"h\":100,\"w\":100})"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "backgroundPhoto",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "transform",
                        "value": {
                          "dpr": 3,
                          "fit": "cover",
                          "h": 167,
                          "w": 500
                        }
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "transformUrl",
                    "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":167,\"w\":500})"
                  },
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "organizerGuildMemberships",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "condition",
                    "value": {
                      "membershipLevel": "ORGANIZER"
                    }
                  },
                  (v13/*: any*/)
                ],
                "concreteType": "GuildMembershipsConnection",
                "kind": "LinkedField",
                "name": "guildMemberships",
                "plural": false,
                "selections": (v14/*: any*/),
                "storageKey": "guildMemberships(condition:{\"membershipLevel\":\"ORGANIZER\"},first:3)"
              },
              {
                "alias": "editorGuildMemberships",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "condition",
                    "value": {
                      "membershipLevel": "EDITOR"
                    }
                  },
                  (v13/*: any*/)
                ],
                "concreteType": "GuildMembershipsConnection",
                "kind": "LinkedField",
                "name": "guildMemberships",
                "plural": false,
                "selections": (v14/*: any*/),
                "storageKey": "guildMemberships(condition:{\"membershipLevel\":\"EDITOR\"},first:3)"
              },
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "type": "User",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v12/*: any*/)
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ec69288cede4604a8de2739752717c006b68dce62805914f018e3348aa1cc56a",
    "metadata": {},
    "name": "UserNavigatorQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1e0365935636feb9de7687eae50e2819";

export default node;
